import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=6eac19d0&scoped=true&"
import script from "./SectionEditor.vue?vue&type=script&lang=ts&"
export * from "./SectionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac19d0",
  null
  
)

export default component.exports